//@flow
import React, {useState} from 'react';
import CustomModal from '../CustomModal/CustomModal';
import {makeStyles, Typography, Button} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import ImageRenderer from '../ImageRenderer';

import type {ImageSource} from '../../entities';

type Props = {
  open: boolean,
  onClose?: () => void,
  images: ImageSource[],
  defaultImage?: ImageSource,
};

const useStyles = makeStyles(() => ({
  container: {
    width: '90vh',
    // height: '90vh',
    maxWidth: 630,
    maxHeight: 672,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    justifyContent: 'center',
    marginBlock: '.75rem',
  },
  title: {
    fontSize: '1.375rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  imageContainer: {
    position: 'relative',
    backgroundColor: colors.grey200,
    borderRadius: '.75rem',
    height: '55vh',
    minHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '470px',

    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
      // objectFit: 'cover',
    },
  },

  footer: {
    display: 'flex',
    gap: '.5rem',
    flexWrap: 'wrap',
    alignItems: 'center',
    width: '100%',
    marginTop: '1rem',
    justifyContent: 'center',
    padding: '1rem 0',
    borderTop: `1px solid ${colors.grey300}`,
  },
  imageButton: {
    padding: 0,
    width: 100,
    height: 100,
    overflow: 'hidden',
    borderRadius: '.5rem',

    '&[data-selected="true"]': {
      border: `3px solid ${colors.primary}`,
    },
  },
  image: {
    width: '100%',
    height: '100%',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function ImagePreviewModal(props: Props) {
  const {open, onClose, images, defaultImage} = props;
  const classes = useStyles();

  const [currentImageIndex, setCurrentImageIndex] = useState(() => {
    const index = images.findIndex(image => image === defaultImage);

    return index === -1 ? 0 : index;
  });

  const currentImage = images[currentImageIndex];

  return (
    <CustomModal open={open} handleCloseModal={onClose}>
      <div className={classes.container}>
        <header className={classes.header}>
          <Typography className={classes.title}>Imágenes</Typography>
        </header>
        <picture className={classes.imageContainer}>
          <ImageRenderer src={currentImage} alt="" />
        </picture>

        {images.length > 1 && (
          <footer className={classes.footer}>
            {images.map((image, index) => {
              const isSelected = index === currentImageIndex;

              return (
                <Button
                  className={classes.imageButton}
                  key={index}
                  data-selected={isSelected}
                  onClick={() => setCurrentImageIndex(index)}
                  disabled={isSelected}
                >
                  <picture className={classes.image}>
                    <ImageRenderer src={image} alt="" />
                  </picture>
                </Button>
              );
            })}
          </footer>
        )}
      </div>
    </CustomModal>
  );
}
